import { PackageInfo, PackageInfoForm } from '../types/index'
const PostRequireParamater = [
  'thumbnail',
  'name',
  'description',
  'packType',
  'movingStatus',
  'keyTexts',
] as const
const PostAdditionalParamater = ['textLang'] as const

const PutRequireParamater = [
  'name',
  'description',
  'keyTexts',
  'packType',
] as const
const PutAdditionalParamger = ['thumbnail', 'textLang'] as const

export const makeFormDataForPackageInfo = (
  packageInfo: PackageInfoForm,
  userOid: string | undefined,
) => {
  console.log(packageInfo)
  const formData = new FormData()
  // create package
  if (userOid) {
    formData.append('author', userOid)
    PostRequireParamater.forEach((key) => {
      const value = packageInfo[key]
      if (value instanceof File || typeof value === 'string') {
        formData.append(key, value)
      } else {
        formData.append(key, JSON.stringify(value))
      }
    })
    PostAdditionalParamater.forEach((key) => {
      const value = packageInfo[key]
      if (value === undefined) return
      if (typeof value !== 'string') {
        formData.append(key, JSON.stringify(value))
      } else {
        formData.append(key, value)
      }
    })
  }
  // update package
  else {
    PutRequireParamater.forEach((key) => {
      const value = packageInfo[key]
      if (typeof value !== 'string') {
        formData.append(key, JSON.stringify(value))
      } else {
        formData.append(key, value)
      }
    })
    PutAdditionalParamger.forEach((key) => {
      const value = packageInfo[key]
      if (value === undefined) return
      if (value instanceof File || typeof value === 'string') {
        formData.append(key, value)
      } else {
        formData.append(key, JSON.stringify(value))
      }
    })
  }

  return formData
}

export function toFormData<T extends object>(formValue: T): FormData {
  const formData = new FormData()

  for (const [key, value] of Object.entries(formValue)) {
    if (value === undefined) continue

    if (typeof value !== 'string' && !(value instanceof File)) {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  }
  return formData
}
